// ScaledCanvas.js
import React, { Component } from "react";
import './scaled-canvas.scss';

const BASE_WIDTH = 1920;
const BASE_HEIGHT = 1080;
const SAFE_MARGIN = 0.96;

class ScaledCanvas extends Component {
    constructor(props) {
        super(props);

        this.contentRef = React.createRef();

        this.state = {
            scaledWidth: BASE_WIDTH,
            scaledHeight: BASE_HEIGHT,
            scale: 1,
            zoom: 1,
            fontScale: 1,
            isReady: false
        };
    }

    componentDidMount() {
        this.calculateScale();
        window.addEventListener("resize", this.calculateScale);
        if (!this.props.isReadOnly) {
            setTimeout(() => {
                this.autoFitVertical()
            }, 5000)
        }

    }

    componentWillUnmount() {
        window.removeEventListener("resize", this.calculateScale);
    }

    // componentDidUpdate(prevProps, prevState) {
    //     // Trigger auto-fit when scale or content changes
    //     if (
    //         prevState.scale !== this.state.scale ||
    //         prevProps.children !== this.props.children
    //     ) {
    //         this.autoFitVertical();
    //     }
    // }


    // 🔥 ONLY VERTICAL AUTO-FIT
    // autoFitVertical = () => {
    //     if (!this.contentRef.current) return;
    //     const FOOTER_HEIGHT = 120;

    //     const rect = this.contentRef.current.getBoundingClientRect();

    //     // remove base scale effect
    //     const contentHeight = rect.height / (this.state.scale * this.state.zoom);

    //     // 👇 subtract footer space
    //     const availableHeight = window.innerHeight - FOOTER_HEIGHT;

    //     let newZoom = 1; // default (no zoom)

    //     // ✅ ONLY when content overflows

    //     if (contentHeight > availableHeight) {
    //         console.log('zoom out called')
    //         newZoom = availableHeight / contentHeight;
    //         // ✅ only zoom OUT
    //         newZoom = Math.min(newZoom, 1);

    //         // avoid unnecessary updates
    //         if (Math.abs(newZoom - this.state.zoom) > 0.01) {
    //             this.setState({
    //                 zoom: newZoom - 0.045,
    //                 isReady: true
    //             });
    //         } else if (!this.state.isReady) {
    //             this.setState({ isReady: true });
    //         }
    //     } else {
    //         console.log('zoom out not called')
    //         this.setState({ isReady: true });
    //     }
    // };

    // autoFitVertical = () => {
    //     if (!this.contentRef.current) return;

    //     const FOOTER_HEIGHT = 120;

    //     const rect = this.contentRef.current.getBoundingClientRect();

    //     const contentHeight = rect.height / (this.state.scale * this.state.zoom);

    //     const availableHeight = window.innerHeight - FOOTER_HEIGHT;

    //     let newZoom = availableHeight / contentHeight;

    //     // ✅ Clamp zoom range (VERY IMPORTANT)
    //     const MIN_ZOOM = 0.6;
    //     const MAX_ZOOM = 1.4; // or 1.2 based on UX

    //     newZoom = Math.max(MIN_ZOOM, Math.min(newZoom, MAX_ZOOM));

    //     // avoid unnecessary updates
    //     if (Math.abs(newZoom - this.state.zoom) > 0.01) {
    //         this.setState({
    //             zoom: newZoom,
    //             isReady: true
    //         });
    //     } else if (!this.state.isReady) {
    //         this.setState({ isReady: true });
    //     }
    // };

    // autoFitVertical = () => {
    //     if (!this.contentRef.current) return;

    //     const FOOTER_HEIGHT = 120;

    //     const rect = this.contentRef.current.getBoundingClientRect();

    //     const contentHeight = rect.height / (this.state.scale * this.state.zoom);

    //     const availableHeight = window.innerHeight - FOOTER_HEIGHT;

    //     let newZoom = this.state.zoom;

    //     const MIN_ZOOM = 0.6;
    //     const MAX_ZOOM = 1.2;

    //     // ✅ CASE 1: Overflow → Zoom OUT
    //     if (contentHeight > availableHeight) {
    //         newZoom = availableHeight / contentHeight;
    //         newZoom = Math.max(newZoom, MIN_ZOOM);
    //     }

    //     // ✅ CASE 2: Extra space → Zoom IN (optional)
    //     else if (contentHeight < availableHeight * 0.85) {
    //         newZoom = availableHeight / contentHeight;
    //         newZoom = Math.min(newZoom, MAX_ZOOM);
    //     }

    //     // ✅ CASE 3: Perfect fit → do nothing

    //     if (Math.abs(newZoom - this.state.zoom) > 0.01) {
    //         this.setState({
    //             zoom: newZoom,
    //             isReady: true
    //         });
    //     } else if (!this.state.isReady) {
    //         this.setState({ isReady: true });
    //     }
    // };

    calculateScale = () => {
        const actualWidth = window.innerWidth;
        const actualHeight = window.innerHeight;

        const scale =
            Math.min(
                actualWidth / BASE_WIDTH,
                actualHeight / BASE_HEIGHT
            ) * SAFE_MARGIN;

        this.setState({
            scaledWidth: BASE_WIDTH * scale,
            scaledHeight: BASE_HEIGHT * scale,
            scale
        });
    };




    // zoomIn = () => {
    //     this.setState(prev => ({
    //         zoom: Math.min(prev.zoom + 0.1, 2)
    //     }));
    // };

    // zoomOut = () => {
    //     this.setState(prev => ({
    //         zoom: Math.max(prev.zoom - 0.1, 1)
    //     }));
    // };

    // zoomIn = () => {
    //     this.setState(prev => ({
    //         zoom: Math.min(prev.zoom + 0.12, 3.0)
    //     }));
    // };

    // // Zoom Out (-0.07)
    // zoomOut = () => {
    //     this.setState(prev => ({
    //         zoom: Math.max(prev.zoom - 0.07, 0.25)
    //     }));
    // };

    autoFitVertical = () => {
        if (!this.contentRef.current) return;

        const FOOTER_HEIGHT = 140;

        const rect = this.contentRef.current.getBoundingClientRect();

        // ✅ Get REAL content height (remove transform effects)
        const contentHeight = rect.height / (this.state.scale * this.state.zoom);

        const availableHeight = window.innerHeight - FOOTER_HEIGHT - 8; // small buffer

        let newZoom = this.state.zoom;
        let newFontScale = this.state.fontScale || 1;

        const MIN_ZOOM = 0.6;
        const MAX_ZOOM = 1.1;

        const MIN_FONT = 0.75;
        const MAX_FONT = 1.1;

        const ratio = availableHeight / contentHeight;

        // 🔥 CASE 1: Content OVERFLOW
        if (contentHeight > availableHeight) {

            if (ratio > 0.9) {
                console.log('font size')
                // ✅ Small overflow → reduce font slightly
                newFontScale = Math.max(ratio, MIN_FONT);
                newFontScale -= 0.1
                newZoom = 1; // keep zoom normal
            } else {
                console.log('zoom out')
                // ✅ Big overflow → zoom out
                newZoom = Math.max(ratio, MIN_ZOOM);
                newFontScale = 1; // reset font
            }

        } else if (contentHeight < availableHeight) {

            const SAFETY_BUFFER = 80;

            let proposedFont = Math.min(ratio * 1.1, MAX_FONT);

            let newHeight =
                contentHeight *
                proposedFont *
                (this.state.scale * this.state.zoom);

                console.log("reducing font 1",proposedFont, newHeight, availableHeight)

            while (
                newHeight >= (availableHeight - SAFETY_BUFFER) &&
                proposedFont > MIN_FONT
            ) {
                proposedFont -= 0.02;

                newHeight =
                    contentHeight *
                    proposedFont *
                    (this.state.scale * this.state.zoom);
                    console.log("reducing font 2",proposedFont, newHeight, availableHeight)
            }

            if(newHeight <= 800) {
                proposedFont = 1.3
            }

            console.log("reducing font 3",proposedFont, newHeight, availableHeight)

            console.log("final font",proposedFont)

            newFontScale = proposedFont;
            newZoom = this.state.zoom;
        } else {
            newZoom = 1;
            newFontScale = 1;
        }
        // 🔥 CASE 2: Extra space (optional zoom-in effect)
        // else if (contentHeight < availableHeight) {


        //     // ✅ try increasing font
        //     let proposedFont = Math.min(ratio * 1.1, MAX_FONT);

        //     // 🔥 simulate new height after font scaling
        //     const newHeight = contentHeight * proposedFont;

        //     // ✅ ONLY apply if it fits
        //     console.log('new height')
        //     if (newHeight <= availableHeight) {
        //         console.log('new height')
        //         newFontScale = proposedFont;
        //     } 

        //     // ❌ Do NOT zoom in aggressively (bad UX)
        //     newZoom = this.state.zoom;

        // } 




        // 🔥 CASE 3: Perfect fit → reset gently

        // ✅ Clamp values
        newZoom = Math.min(Math.max(newZoom, MIN_ZOOM), MAX_ZOOM);
        newFontScale = Math.min(Math.max(newFontScale, MIN_FONT), MAX_FONT);

        // ✅ Prevent unnecessary re-render
        if (
            Math.abs(newZoom - this.state.zoom) > 0.01 ||
            Math.abs(newFontScale - this.state.fontScale) > 0.01
        ) {
            this.setState({
                zoom: newZoom,
                fontScale: newFontScale,
                availableHeight,
                isReady: true
            });
        } else if (!this.state.isReady) {
            this.setState({ isReady: true });
        }
    };





    zoomIn = () => {
        this.setState(prev => {
            let newFontScale = prev.fontScale + 0.08;
            let newZoom = prev.zoom;

            const MAX_FONT = 2.5;
            const MAX_ZOOM = 3;

            // ✅ increase font first
            if (newFontScale <= MAX_FONT) {
                return {
                    fontScale: newFontScale
                };
            }

            // ✅ then increase actual zoom
            newZoom = Math.min(prev.zoom + 0.12, MAX_ZOOM);

            return {
                fontScale: MAX_FONT,
                zoom: newZoom
            };
        });
    };

    zoomOut = () => {
        this.setState(prev => {
            let newFontScale = prev.fontScale - 0.08;
            let newZoom = prev.zoom;

            const MIN_FONT = 0.75;
            const MIN_ZOOM = 0.25;

            // ✅ reduce font first
            if (newFontScale >= MIN_FONT) {
                return {
                    fontScale: newFontScale
                };
            }

            // ✅ then reduce actual zoom
            newZoom = Math.max(prev.zoom - 0.07, MIN_ZOOM);

            return {
                fontScale: MIN_FONT,
                zoom: newZoom
            };
        });
    };


    // resetZoom = () => {
    //     this.setState({ zoom: 1 });
    // };

    resetZoom = () => {
        this.manualZoom = false; // allow autoFit again

        this.setState({
            zoom: 1,
            fontScale: 1,
            isReady: true
        });
    };

    render() {
    const {
        scaledWidth,
        scaledHeight,
        scale,
        zoom,
        isReady,
        availableHeight
    } = this.state;

    const finalScale = scale * zoom;
    const FOOTER_HEIGHT = 140;

    return (
        <div
            className="scalled-canvass"
            style={{
                width: "100vw",
                height: "100vh",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                overflow: this.props.isReadOnly ? "scroll" : "hidden",
                position: "fixed",
                top: 0,
                left: 0
            }}
        >
            <div
                style={{
                    width: scaledWidth,
                    height: scaledHeight,
                    position: "relative",
                    overflow: "visible"
                }}
            >
                {/* ✅ Content wrapper WITHOUT absolute */}
                <div
                    ref={this.contentRef}
                    style={{
                        width: BASE_WIDTH,
                        height: "auto",

                        /* 🔥 changed from absolute → relative */
                        position: "relative",

                        /* reserve footer space */
                        marginBottom: `${FOOTER_HEIGHT}px`,

                        transform: `scale(${finalScale})`,
                        transformOrigin: "top left",
                        transition: "transform 0.25s ease",
                        visibility: isReady ? "visible" : "visible"
                    }}
                >
                    <div
                        style={{
                            fontSize: `${this.state.fontScale}em`
                        }}
                    >
                        {this.props.children(finalScale)}
                    </div>
                </div>

                {/* ✅ NON-SCALED Footer */}
                <div
                    style={{
                        position: "fixed",
                        bottom: "0px",
                        left: "0px",
                        width: "100%",
                        zIndex: 10,
                        height: `${FOOTER_HEIGHT}px`,
                        backgroundColor:
                            !this.props.showQuestionTimerCountdown ||
                            this.props.isReadOnly
                                ? "rgba(230, 224, 252, 1)"
                                : ""
                    }}
                >
                    {this.props.footer}
                </div>
            </div>
        </div>
    );
}

    // render() {
    //     const { scaledWidth, scaledHeight, scale, zoom, isReady, availableHeight } = this.state;

    //     const finalScale = scale * zoom;

    //     return (
    //         <div className="scalled-canvass"
    //             style={{
    //                 width: "100vw",
    //                 height: "100vh",
    //                 // background: "#FFFF",
    //                 display: "flex",
    //                 justifyContent: "center",
    //                 alignItems: "center",
    //                 // overflow: "hidden",
    //                 overflow : `${this.props.isReadOnly ? 'scroll' : 'hidden'}`,
    //                 position: "fixed",
    //                 top: 0,
    //                 left: 0
    //             }}
    //         >
    //             <div
    //                 style={{
    //                     width: scaledWidth,
    //                     height: scaledHeight,
    //                     // height : 'auto',
    //                     // background: "white",
    //                     position: "relative",
    //                     overflow: 'visible'
    //                 }}
    //             >
    //                 <div ref={this.contentRef}
    //                     style={{
    //                         position: "absolute",
    //                         top: 0,
    //                         left: 0,
    //                         width: BASE_WIDTH,
    //                         // height: BASE_HEIGHT,
    //                         height: "auto", // 🔥 MUST BE AUTO
    //                         // maxHeight : `${availableHeight}`,
    //                         // minHeight: BASE_HEIGHT, // optional safety

    //                         transform: `scale(${finalScale})`,
    //                         transformOrigin: "top left",
    //                         transition: "transform 0.25s ease", // ✅ smooth zoom
    //                         visibility: isReady ? "visible" : "visible"
    //                     }}
    //                 >
    //                     <div
    //                         style={{
    //                             fontSize: `${this.state.fontScale}em`
    //                         }}
    //                     >
    //                         {this.props.children(finalScale)}
    //                     </div>
    //                 </div>
    //                 {/* ✅ NON-SCALED Footer */}
    //                 <div
    //                     style={{
    //                         position: "fixed",
    //                         bottom: '0px',
    //                         left: "0px",
    //                         width: "100%",
    //                         zIndex: "10",
    //                         height: "8.5rem",
    //                         backgroundColor: !this.props.showQuestionTimerCountdown || this.props.isReadOnly ? 'rgba(230, 224, 252, 1)' : ''
    //                     }}
    //                 >
    //                     {this.props.footer}
    //                 </div>
    //             </div>
    //         </div>
    //     );
    // }
}

export default ScaledCanvas;